export function getTooltipTitleSx({ allowWrap, maxLines, bubbleMaxWidth }) {
  const wrapSx =
    allowWrap && maxLines === undefined
      ? {
          whiteSpace: 'normal',
          overflowWrap: 'anywhere',
          maxWidth: 'min(360px, 85vw)',
          textAlign: 'center',
        }
      : {}

  const clampSx =
    maxLines === 2
      ? {
          whiteSpace: 'normal',
          display: '-webkit-box',
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: 2,
          overflow: 'hidden',
          overflowWrap: 'anywhere',
          wordBreak: 'break-word',
          maxWidth: 'min(320px, 92vw)',
          textAlign: 'center',
          boxSizing: 'border-box',
        }
      : {}

  return {
    fontSize: 'var(--app-font-size-sm)',
    lineHeight: 1.2,
    px: '4px',
    py: '3px',
    bgcolor: 'rgba(43, 43, 43, 0.95)',
    color: 'common.white',
    borderRadius: 'var(--app-radius-xs)',
    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.2)',
    pointerEvents: 'none',
    ...wrapSx,
    ...clampSx,
    ...(bubbleMaxWidth != null ? { maxWidth: bubbleMaxWidth, width: 'fit-content' } : {}),
  }
}
